/**
 * Styling Helpers
 * @see https://github.com/spring-media/la-interactive-web/wiki/Styling-Helper-Utilities
 */

export const FontFace = (
  name: string,
  src: string,
  fontWeight: string | number = "normal",
  fontStyle = "normal"
): string => {
  return `@font-face {
            font-family: "${name}";
            font-weight: ${fontWeight};
            font-style: ${fontStyle};
            font-display: fallback;
            src: url("${src}.woff2") format("woff2"),
                url("${src}.woff") format("woff"),
                url("${src}.ttf") format("truetype");
        }`;
};

export const HEXtoRGBA = (hex: string, alpha?: number): string => {
  const r = Number.parseInt(hex.slice(1, 3), 16),
    g = Number.parseInt(hex.slice(3, 5), 16),
    b = Number.parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  return `rgba(${r}, ${g}, ${b})`;
};

export const RGBAtoHEX = (rgba: string): string => {
  const trim = (str: string): string => str.trim();
  const parts = rgba.substring(rgba.indexOf("(")).split(",");
  const r = Number.parseInt(trim(parts[0].substring(1)), 10);
  const g = Number.parseInt(trim(parts[1]), 10);
  const b = Number.parseInt(trim(parts[2]), 10);
  const a = parts[3]
    ? Number.parseFloat(
        trim(parts[3].substring(0, parts[3].length - 1))
      ).toFixed(2)
    : undefined;

  if (a) {
    return (
      "#" +
      r.toString(16) +
      g.toString(16) +
      b.toString(16) +
      (+a * 255).toString(16).substring(0, 2)
    );
  }

  return "#" + r.toString(16) + g.toString(16) + b.toString(16);
};
